import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkPagingButton } from './uitk-paging-button.esm.js';

var UitkPagingNextButton = /** @class */ (function (_super) {
    __extends(UitkPagingNextButton, _super);
    function UitkPagingNextButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkPagingNextButton.prototype.render = function () {
        return React.createElement(UitkPagingButton, __assign({}, this.props, { icon: "chevron_right" }));
    };
    UitkPagingNextButton.displayName = 'UitkPagingNextButton';
    return UitkPagingNextButton;
}(React.Component));

export { UitkPagingNextButton };
